export const FETCH_GARMENTS_DETAILS_SUCCESS = 'FETCH_GARMENTS_DETAILS_SUCCESS';
export const FETCH_GARMENTS_DETAILS_FAILURE = 'FETCH_GARMENTS_DETAILS_FAILURE';

export const FETCH_FABRIC_DETAILS_SUCCESS = 'FETCH_FABRIC_DETAILS_SUCCESS';
export const FETCH_FABRIC_DETAILS_FAILURE = 'FETCH_FABRIC_DETAILS_FAILURE';

export const FETCH_EMBELLISHMENT_DETAILS_SUCCESS = 'FETCH_EMBELLISHMENT_DETAILS_SUCCESS';
export const FETCH_EMBELLISHMENT_DETAILS_FAILURE = 'FETCH_EMBELLISHMENT_DETAILS_FAILURE';

export const FETCH_TRIMS_DETAILS_SUCCESS = 'FETCH_TRIMS_DETAILS_SUCCESS';
export const FETCH_TRIMS_DETAILS_FAILURE = 'FETCH_TRIMS_DETAILS_FAILURE';

export const FETCH_BRANDING_DETAILS_SUCCESS = 'FETCH_BRANDING_DETAILS_SUCCESS';
export const FETCH_BRANDING_DETAILS_FAILURE = 'FETCH_BRANDING_DETAILS_FAILURE';

export const FETCH_WASHING_DETAILS_SUCCESS = 'FETCH_WASHING_DETAILS_SUCCESS';
export const FETCH_WASHING_DETAILS_FAILURE = 'FETCH_WASHING_DETAILS_FAILURE';

export const FETCH_MATERIALS_DETAILS_SUCCESS = 'FETCH_MATERIALS_DETAILS_SUCCESS';
export const FETCH_MATERIALS_DETAILS_FAILURE = 'FETCH_MATERIALS_DETAILS_FAILURE';

export const FETCH_MATERIAL_SUPPLIERS_SUCCESS = 'FETCH_MATERIAL_SUPPLIERS_SUCCESS';
export const FETCH_MORE_MATERIAL_SUPPLIERS_SUCCESS = 'FETCH_MORE_MATERIAL_SUPPLIERS_SUCCESS';
export const FETCH_MATERIAL_SUPPLIERS_FAILURE = 'FETCH_MATERIALS_SUPPLIERS_FAILURE';

export const FETCH_PINNED_MATERIALS_SUCCESS = 'FETCH_PINNED_MATERIALS_SUCCESS';
export const FETCH_PINNED_MATERIALS_FAILURE = 'FETCH_PINNED_MATERIALS_FAILURE';
export const LIKE_MATERIAL_SUCCESS = 'LIKE_MATERIAL_SUCCESS';
export const UNLIKE_MATERIAL_SUCCESS = 'UNLIKE_MATERIAL_SUCCESS';
export const LIKE_MATERIAL_FAILURE = 'LIKE_MATERIAL_FAILURE';
export const UNLIKE_MATERIAL_FAILURE = 'UNLIKE_MATERIAL_FAILURE';
